<input type="text"
       [placeholder]="_placeholder"
       matInput
       #input
       [disabled]="disabled"
       [required]="true"
       [value]="value?.label"
       (input)="onInputChange($event)"
       (focus)="onFocusIn($event)"
       (blur)="onFocusOut($event)"
       [matAutocomplete]="locationsAuto">
       
<mat-autocomplete 
    #locationsAuto="matAutocomplete" 
    [displayWith]="displayFn" 
    requireSelection
    (optionSelected)="onAutocompleteSelection($event)">
    
  <mat-option *ngFor="let option of locationOptions | async" [value]="option">
    {{option.label}}
  </mat-option>
</mat-autocomplete>